import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-890856ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title about" }, "2. 公開調査について", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-text about" }, [
  /*#__PURE__*/_createElementVNode("p", null, "国立国会図書館では、資料をインターネット公開するために、著作者に関する公開調査を実施しています。"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("公開調査により著作者の"),
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.bunka.go.jp/seisaku/chosakuken/hokaisei/kantaiheiyo_chosakuken/1411890.html" }, "著作権保護期間満了"),
    /*#__PURE__*/_createTextVNode("であることが確認できた場合は、著作権保護期間満了としてインターネット公開を行います。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "著作権保護期間内であり、著作権者のご連絡先が判明した場合、利用に関して許諾依頼を行い、許諾が得られましたら、インターネット公開を行います。"),
  /*#__PURE__*/_createElementVNode("p", null, "皆様からの情報をお待ちしています。ご協力をよろしくお願いいたします。")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "2-1. ご提供いただきたい情報", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "2-2. 情報ご提供までの流れ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "2-3. これまでの調査", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "2-4. お問い合わせ", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollPage('request'))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.scrollPage('request')), ["prevent"]), ["space","enter"])),
        class: "link-button button-request"
      }, _hoisted_5, 32),
      _hoisted_6,
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollPage('reference'))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.scrollPage('reference')), ["prevent"]), ["space","enter"])),
        class: "link-button button-reference"
      }, _hoisted_8, 32),
      _hoisted_9,
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollPage('notification'))),
        onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.scrollPage('notification')), ["prevent"]), ["space","enter"])),
        class: "link-button button-notification"
      }, _hoisted_11, 32),
      _hoisted_12,
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.scrollPage('inquiry'))),
        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.scrollPage('inquiry')), ["prevent"]), ["space","enter"])),
        class: "link-button button-inquiry"
      }, _hoisted_14, 32),
      _hoisted_15
    ]),
    _createVNode(_component_ToPageTop)
  ]))
}